import { ChevronDown, LogOut, Menu } from "lucide-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../../hooks/MyContextProvider";

const Header = () => {
  const navigate = useNavigate();
  const { updateAdminToken, updateUser, setOpen, open } = useContext(MyContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const onPointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onPointerDown);
    return () => document.removeEventListener("mousedown", onPointerDown);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    updateAdminToken("");
    updateUser({});
    navigate("/administration");
  };

  return (
    <header className="admin-header page-header">
      <div className="admin-header__inner header-wrapper">
        <div className="admin-header__left">
          <button
            type="button"
            className="admin-header__menu-btn"
            aria-label="Toggle sidebar"
            onClick={() => setOpen(!open)}
          >
            <Menu size={20} />
          </button>

          <div className="admin-header__welcome">
            <p className="admin-header__eyebrow">Administration</p>
            <h1 className="admin-header__title">Welcome to TRISA</h1>
            <p className="admin-header__subtitle">
              Here’s what’s happening with your store today.
            </p>
          </div>
        </div>

        <div className="admin-header__right" ref={menuRef}>
          <button
            type="button"
            className={`admin-header__profile${menuOpen ? " is-open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-expanded={menuOpen}
            aria-haspopup="true"
          >
            <span className="admin-header__avatar" aria-hidden="true">
              T
            </span>
            <span className="admin-header__profile-meta">
              <span className="admin-header__profile-name">Trisa</span>
              <span className="admin-header__profile-role">Admin</span>
            </span>
            <ChevronDown size={16} className="admin-header__chevron" />
          </button>

          {menuOpen && (
            <div className="admin-header__dropdown" role="menu">
              <button
                type="button"
                className="admin-header__dropdown-item admin-header__dropdown-item--danger"
                role="menuitem"
                onClick={handleLogout}
              >
                <LogOut size={16} />
                <span>Log Out</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
